import { createContext } from 'react';
import type { IReadDocumentElement } from '@raas/shared/src/types/document-element';
import type { ILegalProvisionDeltaDetails } from '@raas/shared/src/types/legal-provision';

export interface IDeltaDataDocumentContext {
  documentElementDetails: IReadDocumentElement | null;
  setDocumentElementDetails: (details: IReadDocumentElement | null) => void;
  fetchDocumentElement: (documentElementId: string) => Promise<IReadDocumentElement>;
  isLoadingPlacementCandidates: boolean;
  legalProvisionPlacementCandidates: ILegalProvisionDeltaDetails | null;
  fetchLegalProvisionPlacementCandidates: () => Promise<void>;
}

const DeltaDataDocumentContext = createContext<IDeltaDataDocumentContext | undefined>(undefined);

export default DeltaDataDocumentContext;
